import React, { Component } from "react";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";
import { TextShow } from "../Essentials/TextShow";
import NotificationDescription from "../Notifications/NotificationDescription";

class InternshipDivisionDescription extends Component {
  render() {
    return (
      <div>
        {this.props.type == "policies-regulations-and-guidelines" ? (
          <TextShow
            title="Policies, Regulations and Guidelines"
            type="INTERNSHIP_DIV_POLICIES"
          />
        ) : null}

        {this.props.type == "annual-internship-reports" ? (
          <div>
            <BreadCrumbOwn title="Annual Internship Reports" />
            <NotificationDescription
              title="Annual Internship Reports"
              code="INTERNSHIP_DIV_ANNUAL_REPORTS"
            />
          </div>
        ) : null}

        {this.props.type == "annual-activity-reports" ? (
          <div>
            <BreadCrumbOwn title="Annual Activity Reports" />
            <NotificationDescription
              title="Annual Activity Reports"
              code="INTERNSHIP_DIV_ACTIVITY_REPORTS"
            />
          </div>
        ) : null}

        {this.props.type == "industry-collaboration-reports" ? (
          <div>
            <BreadCrumbOwn title="Industry Collaboration Reports" />
            <NotificationDescription
              title="Industry Collaboration Reports"
              code="INTERNSHIP_DIV_COLLABORATION_REPORTS"
            />
          </div>
        ) : null}

        {this.props.type == "special-reports" ? (
          <div>
            <BreadCrumbOwn title="Special Reports" />
            <NotificationDescription
              title="Special Reports"
              code="INTERNSHIP_DIV_SPECIAL_REPORTS"
            />
          </div>
        ) : null}

        {this.props.type == "documents" ? (
          <div>
            <BreadCrumbOwn title="Documents" />
            <NotificationDescription
              title="Documents"
              code="INTERNSHIP_DIV_DOCUMENTS"
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default InternshipDivisionDescription;
